export const getRequired = (id) => {
    let wrapper = document.getElementById(id);
    if (!wrapper) {
        throw new Error(`No element with ${id} found`);
    }
    return wrapper;
}

export const create = (owner, tag, props) => owner.appendChild(Object.assign(document.createElement(tag), props ?? {}));

export const createDiv = (owner, props) => create(owner, 'div', props);